// --------------------------------------------------------------------------
// accordion.js
// --------------------------------------------------------------------------

RN.accordion = function() {

  'use strict';

  function init() {
    byBehaviour('accordion-trigger').on('click', accordion);
  }

  function accordion() {
    var thisButton = $(this)
    var accordionEl = thisButton.closest(byElement('accordion'))
    var type = accordionEl.data('type')
    accordionEl.toggleClass('accordion--active')

    if (type !== 'steps') {
        var buttonText = thisButton.text();
        var buttonMoreText = thisButton.attr("data-more");
        var buttonLessText = thisButton.attr("data-less");

        thisButton.text(buttonText === buttonMoreText ? buttonLessText : buttonMoreText)
    }

    return false;
  }

  return {
    init: init
  };

}();